/* Instachiq fast add-to-cart + animations (atc-fx) */
(function () {
  'use strict';
  var C = window.ATCFX || {};
  var ANIM = C.anim || 'fly';
  var AFTER = C.after || 'drawer';
  var SPEED = Number(C.speed) || 650;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) ANIM = 'none';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight;
  }
  function cartIcon() {
    var list = document.querySelectorAll('.m-cart-icon-bubble, [data-cart-icon], a[href$="/cart"]');
    for (var i = 0; i < list.length; i++) if (visible(list[i])) return list[i];
    return list[0] || null;
  }
  function productImage(form) {
    var scopes = [
      form.closest('.m-product-card, .m-product-quickview, .m-sticky-addtocart, [data-product-card]'),
      form.closest('.m-main-product, .m-product-main, section, .shopify-section'),
      document.querySelector('.m-main-product, main')
    ];
    for (var s = 0; s < scopes.length; s++) {
      if (!scopes[s]) continue;
      var imgs = scopes[s].querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i], r = im.getBoundingClientRect();
        if (r.width > 60 && r.height > 60 && r.bottom > 0 && r.top < innerHeight) return im;
      }
    }
    return null;
  }
  function centre(el) { var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2, w: r.width, h: r.height }; }

  /* ---------- count bubble ---------- */
  function readCount() {
    var b = document.querySelector('.m-cart-count-bubble');
    return b ? parseInt(b.textContent, 10) || 0 : 0;
  }
  function setCount(n) {
    document.querySelectorAll('.m-cart-count-bubble').forEach(function (b) {
      if (n > 0) { b.textContent = n; b.classList.remove('m:hidden'); } else b.classList.add('m:hidden');
    });
  }
  function bump() {
    var ic = cartIcon(); if (!ic) return;
    ic.classList.remove('atcfx-bump'); void ic.offsetWidth; ic.classList.add('atcfx-bump');
    setTimeout(function () { ic.classList.remove('atcfx-bump'); }, 700);
  }

  /* ---------- animations (each returns a promise resolving on landing) ---------- */
  function ghost(src, from, size, round) {
    var g = document.createElement('div');
    g.className = 'atcfx-ghost' + (round ? ' atcfx-round' : '');
    g.style.cssText = 'left:' + (from.x - size / 2) + 'px;top:' + (from.y - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px';
    if (src) g.style.backgroundImage = 'url("' + src + '")';
    document.body.appendChild(g);
    return g;
  }
  function animFly(img, btn) {
    var ic = cartIcon(); if (!ic) return Promise.resolve();
    var src = img ? (img.currentSrc || img.src) : '';
    var a = centre(img || btn), b = centre(ic), size = Math.min(img ? Math.max(a.w, a.h) : 80, 260);
    var g = ghost(src, a, size, false);
    return g.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '16px' },
      { transform: 'translate(' + (b.x - a.x) * 0.55 + 'px,' + (b.y - a.y) * 0.55 + 'px) scale(.55)', opacity: 1, borderRadius: '30%', offset: 0.55 },
      { transform: 'translate(' + (b.x - a.x) + 'px,' + (b.y - a.y) + 'px) scale(.08)', opacity: .3, borderRadius: '50%' }
    ], { duration: SPEED, easing: 'cubic-bezier(.55,0,.25,1)', fill: 'forwards' }).finished.then(function () { g.remove(); });
  }
  function animArc(img, btn) {
    var ic = cartIcon(); if (!ic) return Promise.resolve();
    var src = img ? (img.currentSrc || img.src) : '';
    var a = centre(img || btn), b = centre(ic), size = Math.min(img ? Math.max(a.w, a.h) * .6 : 70, 170);
    var outer = document.createElement('div');
    outer.className = 'atcfx-arc';
    outer.style.cssText = 'left:' + a.x + 'px;top:' + a.y + 'px';
    var inner = ghost(src, { x: 0, y: 0 }, size, true);
    inner.style.position = 'absolute';
    outer.appendChild(inner); document.body.appendChild(outer);
    var dur = SPEED * 1.25, lift = Math.min(220, Math.abs(b.x - a.x) * .35 + 120);
    outer.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + (b.x - a.x) + 'px)' }], { duration: dur, easing: 'linear', fill: 'forwards' });
    inner.animate([
      { transform: 'translateY(0) rotate(0) scale(1)' },
      { transform: 'translateY(' + (Math.min(a.y, b.y) - a.y - lift) + 'px) rotate(200deg) scale(.7)', offset: .4, easing: 'cubic-bezier(.33,0,.67,1)' },
      { transform: 'translateY(' + (b.y - a.y) + 'px) rotate(420deg) scale(.12)' }
    ], { duration: dur, easing: 'cubic-bezier(.5,0,.75,1)', fill: 'forwards' });
    return new Promise(function (res) { setTimeout(function () { outer.remove(); res(); }, dur); });
  }
  function animDrop(img, btn) {
    var ic = cartIcon(); if (!ic) return Promise.resolve();
    var src = img ? (img.currentSrc || img.src) : '';
    var a = centre(btn), b = centre(ic);
    var g = ghost(src, a, 64, true);
    g.classList.add('atcfx-bubble');
    return g.animate([
      { transform: 'translate(0,0) scale(0)', opacity: 0 },
      { transform: 'translate(0,-40px) scale(1.15)', opacity: 1, offset: .25 },
      { transform: 'translate(0,-40px) scale(1)', opacity: 1, offset: .35 },
      { transform: 'translate(' + (b.x - a.x) + 'px,' + (b.y - a.y) + 'px) scale(.25)', opacity: .9 }
    ], { duration: SPEED * 1.3, easing: 'cubic-bezier(.6,-.2,.3,1.2)', fill: 'forwards' }).finished.then(function () { g.remove(); });
  }
  function animSparkle(img, btn) {
    var a = centre(btn), n = 18, colors = ['#f0d27a', '#e3b94a', '#c59a2e', '#fff6d8'];
    for (var i = 0; i < n; i++) {
      var p = document.createElement('i');
      p.className = 'atcfx-spark';
      var ang = (Math.PI * 2 * i) / n + Math.random() * .4, dist = 50 + Math.random() * 70, s = 5 + Math.random() * 6;
      p.style.cssText = 'left:' + a.x + 'px;top:' + a.y + 'px;width:' + s + 'px;height:' + s + 'px;background:' + colors[i % 4];
      document.body.appendChild(p);
      p.animate([
        { transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
        { transform: 'translate(calc(-50% + ' + Math.cos(ang) * dist + 'px),calc(-50% + ' + Math.sin(ang) * dist + 'px)) scale(.2)', opacity: 0 }
      ], { duration: 700 + Math.random() * 300, easing: 'cubic-bezier(.2,.8,.3,1)', fill: 'forwards' }).finished.then((function (el) { return function () { el.remove(); }; })(p));
    }
    var ring = document.createElement('i'); ring.className = 'atcfx-ring';
    ring.style.cssText = 'left:' + a.x + 'px;top:' + a.y + 'px';
    document.body.appendChild(ring);
    ring.animate([{ transform: 'translate(-50%,-50%) scale(.2)', opacity: .9 }, { transform: 'translate(-50%,-50%) scale(3.2)', opacity: 0 }], { duration: 650, easing: 'ease-out' }).finished.then(function () { ring.remove(); });
    return new Promise(function (r) { setTimeout(r, 380); });
  }
  var ANIMS = { fly: animFly, arc: animArc, drop: animDrop, sparkle: animSparkle };

  /* ---------- button feedback ---------- */
  function btnState(btn, state) {
    if (!btn) return;
    btn.classList.remove('atcfx-ok', 'atcfx-busy');
    if (state) btn.classList.add('atcfx-' + state);
    if (state === 'ok') setTimeout(function () { btn.classList.remove('atcfx-ok'); }, 1600);
  }

  /* ---------- drawer helpers ---------- */
  function drawer() { return document.querySelector('m-cart-drawer'); }
  function skeleton(dr, img, title) {
    var box = dr && dr.querySelector('.m-cart-drawer__items, [data-minimog-cart-items] form');
    if (!box) return;
    var old = box.querySelector('.atcfx-skel'); if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'atcfx-skel';
    el.innerHTML = '<span class="atcfx-skel__img"' + (img ? ' style="background-image:url(\'' + (img.currentSrc || img.src) + '\')"' : '') + '></span><span class="atcfx-skel__txt"><b></b><b></b></span>';
    box.insertBefore(el, box.firstChild);
  }
  function renderDrawer(dr, open) {
    return fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (!dr || !sections || !sections['cart-drawer']) return;
        if (open) dr.renderContents({ sections: sections });
        else dr.getSectionsToRender().forEach(function (s) {
          var t = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (t) t.innerHTML = dr.getSectionInnerHTML(sections['cart-drawer'], s.selector);
        });
        if (window.FoxKitV2 && FoxKitV2.Modules && FoxKitV2.Modules.InCart) try { FoxKitV2.Modules.InCart.getCart(); } catch (e) {}
      });
  }
  function toast(type, msg, target) {
    try {
      MinimogTheme.Notification.show({ target: target || document.body, method: 'appendChild', type: type, message: msg, last: 3000, sticky: !target });
    } catch (e) {}
  }

  /* ---------- the fast submit handler ---------- */
  function isAtcForm(f) {
    if (!f || f.tagName !== 'FORM') return false;
    var a = f.getAttribute('action') || '';
    return /\/cart\/add/.test(a) && !f.closest('.product-bundles');
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAtcForm(form) || C.enabled === false) return;
    var settings = window.MinimogSettings || {};
    if (settings.use_ajax_atc === false) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return; /* let theme show "select variant" */
    if (typeof window.validateForm === 'function') {
      var info = form.closest('.m-main-product--info');
      var bad = info && validateForm(info);
      if (bad && bad.length) return; /* theme handles required custom fields */
    }
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

    var btn = (e.submitter && form.contains(e.submitter) ? e.submitter : null) || form.querySelector('[type="submit"], [name="add"]');
    if (btn && btn.classList.contains('atcfx-busy')) return;
    var img = productImage(form);
    var dr = drawer();
    var qtyField = form.querySelector('[name="quantity"]');
    var qty = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
    var before = readCount();
    var fd = new FormData(form);

    btnState(btn, 'busy');
    var t0 = performance.now();
    var req = fetch(root + 'cart/add.js', {
      method: 'POST', body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok && !j.status, data: j }; }); });

    var anim = (ANIMS[ANIM] ? ANIMS[ANIM](img, btn) : Promise.resolve()).catch(function () {});
    anim.then(function () { bump(); });

    /* optimistic: count bubbles up as the image lands */
    anim.then(function () { setCount(before + qty); });

    var useDrawer = AFTER === 'drawer' && dr && settings.enable_cart_drawer;
    if (useDrawer) anim.then(function () { skeleton(dr, img); dr.open(); });

    req.then(function (res) {
      if (window.ATCFX_DEBUG) console.log('[atc-fx] add.js', Math.round(performance.now() - t0) + 'ms');
      if (!res.ok) {
        btnState(btn, null); setCount(before);
        if (useDrawer) anim.then(function () { dr.close(); });
        var errBox = form.closest('.m-main-product--info');
        toast('error', res.data.description || res.data.message || 'Error', errBox && errBox.querySelector('[data-error-wrapper], .m-product-form--error'));
        return;
      }
      btnState(btn, 'ok');
      if (dr) {
        renderDrawer(dr, false).then(function () {
          if (window.ATCFX_DEBUG) console.log('[atc-fx] drawer ready', Math.round(performance.now() - t0) + 'ms');
          dr.classList.remove('m-cart--empty');
          var sk = dr.querySelector('.atcfx-skel'); if (sk) sk.remove();
        });
      }
      if (!useDrawer) toast('success', (window.MinimogStrings && MinimogStrings.itemAdded) || 'Added to cart');
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        setCount(cart.item_count);
        try { MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, Object.assign({}, cart, { source: 'main-cart-items' })); } catch (e) {}
      });
    }).catch(function () {
      btnState(btn, null); setCount(before);
      form.submit(); /* network/js failure: fall back to normal form post */
    });
  }, true);
})();
